import { ReactComponent as CallIcon } from "../assets/call.svg";
import { ReactComponent as MessageIcon } from "../assets/message.svg";
import { ReactComponent as LocationIcon } from "../assets/location.svg";

export const aboutLinks = [
  {
    id: 1,
    title: "+1 (604) 313-2828",
    link: "tel: +1 (604) 313-2828",
    icon: <CallIcon />,
  },
  {
    id: 2,
    title: "info@instabuild.com",
    link: "mailto: info@instabuild.com",
    icon: <MessageIcon />,
  },
  {
    id: 3,
    title: "7337 137 St, Surrey, BC, V3W 1A4",
    link: "#",
    icon: <LocationIcon />,
  },
];

export const categoriesLinks = [
  {
    id: 1,
    title: "Roofing",
    link: "",
  },
  {
    id: 2,
    title: "Lumber",
    link: "",
  },
  {
    id: 3,
    title: "Sliding & Panels",
    link: "",
  },
  {
    id: 4,
    title: "Dry wall Insulation",
    link: "",
  },
  {
    id: 5,
    title: "Tools & accessories",
    link: "",
  },
  {
    id: 6,
    title: "Closet & storage",
    link: "",
  },
  {
    id: 7,
    title: "Stone & Tiles",
    link: "",
  },
];

export const supportLinks = [
  {
    id: 1,
    title: "About Us",
    link: "/about-us",
  },
  {
    id: 2,
    title: "Contact Us",
    link: "/contact",
  },
  {
    id: 3,
    title: "Privacy Policy",
    link: "/privacy-policy",
  },
  {
    id: 4,
    title: "Terms & Conditions",
    link: "/terms-and-conditions",
  },
  {
    id: 5,
    title: "Return Policy",
    link: "/return-policy",
  },
  {
    id: 7,
    title: "Careers",
    link: "/careers",
  },
];

export const links = [
  {
    id: 1,
    title: "Products List",
    link: "/search",
  },
  {
    id: 4,
    title: "Shopping Cart",
    link: "/cart",
  },
  {
    id: 5,
    title: "Blog",
    link: "/blogs",
  },
];

export const socialLinks = [
  {
    id: 1,
    title: "Twitter",
    link: "https://x.com/Instabuildpro",
  },
  {
    id: 2,
    title: "Instagram",
    link: "https://www.instagram.com/instabuild.official/",
  },
  {
    id: 3,
    title: "Facebook",
    link: "https://www.facebook.com/profile.php?id=61585211781544",
  },
  {
    id: 4,
    title: "Youtube",
    link: "https://www.youtube.com/@InstaBuild.official",
  },
];
